import ComponentName from '@Constant/componentName'

const uniteOrder = [
  {
    component: () => import('../../views/layout/Index.vue'),
    path: '/unite',
    name: ComponentName.uniteOrder.home,
    auth: '*',
    children: [
      {
        component: () => import('../../views/uniteOrder/list/Index.vue'),
        path: 'index',
        name: ComponentName.uniteOrder.index,
        auth: '*',
        meta: {
          title: '联合投稿列表'
        },
        children: [
          {
            component: () => import('../../views/uniteOrder/update/Create.vue'),
            path: 'create',
            name: ComponentName.uniteOrder.create,
            auth: '*',
            meta: {
              title: '创建联合投稿'
            }
          },
          {
            component: () => import('../../views/uniteOrder/update/Edit.vue'),
            path: 'edit/:publishId',
            name: ComponentName.uniteOrder.edit,
            props: true,
            auth: '*',
            meta: {
              title: '编辑联合投稿'
            }
          },
          {
            component: () => import('../../views/uniteOrder/detail/Index.vue'),
            path: 'detail/:publishId',
            name: ComponentName.uniteOrder.detail,
            props: true,
            auth: '*',
            meta: {
              title: '联合投稿详情'
            }
          }
        ]
      }
    ]
  }
]

export default uniteOrder
